import { z } from 'zod';

import { IsoDateTimeSchema, UuidSchema, BooleanQueryParamSchema } from './common.js';
import { PaginationQuerySchema, paginatedResponseSchema } from './pagination.js';
import { MasterCodeSchema } from './query-types.js';

/**
 * Query Medium master (Masters → Query Mediums). The channel a lead came
 * through (e.g. "phone", "email", "whatsapp"). A pure simple master - see
 * ADR-0016 / ADR-0023 for the standard shape.
 */

export const QueryMediumListItemSchema = z.object({
  id: UuidSchema,
  legacyId: z.number().int().nullable(),
  code: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  isActive: z.boolean(),
  sortOrder: z.number().int(),
  createdAt: IsoDateTimeSchema,
});
export type QueryMediumListItem = z.infer<typeof QueryMediumListItemSchema>;

export const QueryMediumListQuerySchema = PaginationQuerySchema.extend({
  isActive: BooleanQueryParamSchema.optional(),
  includeDeleted: BooleanQueryParamSchema.optional(),
});
export type QueryMediumListQuery = z.infer<typeof QueryMediumListQuerySchema>;

export const QueryMediumListResponseSchema = paginatedResponseSchema(QueryMediumListItemSchema);
export type QueryMediumListResponse = z.infer<typeof QueryMediumListResponseSchema>;

export const QueryMediumDetailSchema = QueryMediumListItemSchema.extend({
  updatedAt: IsoDateTimeSchema,
  deletedAt: IsoDateTimeSchema.nullable(),
});
export type QueryMediumDetail = z.infer<typeof QueryMediumDetailSchema>;

const QueryMediumCoreFieldsSchema = z.object({
  code: MasterCodeSchema,
  name: z.string().trim().min(1, 'Name is required').max(120),
  description: z.string().trim().max(500).nullable().optional(),
  legacyId: z.number().int().positive().nullable().optional(),
  isActive: z.boolean().optional(),
  sortOrder: z.number().int().min(0).optional(),
});

export const CreateQueryMediumRequestSchema = QueryMediumCoreFieldsSchema;
export type CreateQueryMediumRequest = z.infer<typeof CreateQueryMediumRequestSchema>;

export const UpdateQueryMediumRequestSchema = QueryMediumCoreFieldsSchema.partial();
export type UpdateQueryMediumRequest = z.infer<typeof UpdateQueryMediumRequestSchema>;
